import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=79884cc1&scoped=true"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79884cc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79884cc1')) {
      api.createRecord('79884cc1', component.options)
    } else {
      api.reload('79884cc1', component.options)
    }
    module.hot.accept("./settings.vue?vue&type=template&id=79884cc1&scoped=true", function () {
      api.rerender('79884cc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/announcement/settings.vue"
export default component.exports